module.exports = __webpack_public_path__ + "img/common_icon.3e3f580c.png";